// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import eventBus from '@/utils/_eventBus.js';
import 'element-ui/lib/theme-chalk/index.css'
import 'jquery'
import './styles/index.css'

// import Vant from 'vant';
import 'vant/lib/index.css';
import { SwipeCell,ImagePreview } from 'vant';

Vue.use(SwipeCell,ImagePreview);
// Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(MintUI);

Vue.config.productionTip = false;
Vue.prototype.$eventBus = eventBus;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js